// src/lib/map/miniMapSync.js
//
// Explore's minimap follows the main map: on each move (throttled, 33 ms) it
// jumps to the main map's center four zooms out and draws the main map's
// bounds as its "viewport" outline. Moved out of MapView's initMiniMap.
//
// A removed map is never called (REM-703): the throttle can run its last call
// after a timeout, by which time either map may have been removed (Explore
// unmounting removes both). Each run asks whether both maps are live; either
// map's "remove" event, or the returned detach, stops the following.
import { throttle } from "../../utils/mapSync";
import { isLiveMap } from "./liveMap";

const boundsPolygon = (b) => ({
  type: "Feature",
  geometry: {
    type: "Polygon",
    coordinates: [[
      [b.getWest(), b.getSouth()],
      [b.getEast(), b.getSouth()],
      [b.getEast(), b.getNorth()],
      [b.getWest(), b.getNorth()],
      [b.getWest(), b.getSouth()],
    ]],
  },
});

/** Keep `miniMap` on `mainMap`'s view. Returns the detach. */
export function followMainMap(mainMap, miniMap, { interval = 33 } = {}) {
  if (!isLiveMap(mainMap) || !isLiveMap(miniMap)) return () => {};
  let live = true;
  const sync = throttle(() => {
    if (!live || !isLiveMap(mainMap) || !isLiveMap(miniMap)) return;
    const c = mainMap.getCenter();
    miniMap.jumpTo({
      center: [c.lng, c.lat],
      zoom: Math.max(mainMap.getZoom() - 4, 1),
      bearing: mainMap.getBearing(),
      pitch: 0,
    });
    miniMap.getSource("viewport")?.setData(boundsPolygon(mainMap.getBounds()));
  }, interval);
  const detach = () => {
    if (!live) return;
    live = false;
    if (isLiveMap(mainMap)) { mainMap.off("move", sync); mainMap.off("remove", detach); }
    if (isLiveMap(miniMap)) miniMap.off("remove", detach);
  };
  mainMap.on("move", sync);
  mainMap.on("remove", detach);
  miniMap.on("remove", detach);
  return detach;
}
